import React from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCity,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';
import GeneralHeader from '../../components/general/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';
// Images
import SammiMainImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body-small.png';
import ContactMainHeader from '../../assets/images/headers/contact-sammi-smith-barbie-style-header.png';

function ContactPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Contact'
        desc={`${CompanyName} - Elite TS Dominatrix & Sensual Goddess in ${LocationCity}`}
        keywords={KeywordsPages}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={ContactMainHeader}
            headerMobileImage={ContactMainHeader}
            mainTitle={`${MainTitle}`}
            subtitle={`Reach out to me and be nice!`}
            mainImage={SammiMainImage}
          />
        </div>

        {/* Main page content */}
        <ContactPageMainContainer />

        <FooterComponent />
      </div>
    </>
  );
}

export default ContactPage;
